import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@api/createBaseQueryWithReauth';

export const editorApi = createApi({
    reducerPath: 'editorApi',
    baseQuery: createBaseQueryWithReauth(import.meta.env.VITE_EDITOR_API_URL),
    keepUnusedDataFor: 0,
    endpoints: () => ({})
});
